import { render, staticRenderFns } from "./AlbumReleaseDialog.vue?vue&type=template&id=616bdb28&scoped=true"
import script from "./AlbumReleaseDialog.vue?vue&type=script&lang=js"
export * from "./AlbumReleaseDialog.vue?vue&type=script&lang=js"
import style0 from "./AlbumReleaseDialog.vue?vue&type=style&index=0&id=616bdb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bdb28",
  null
  
)

export default component.exports